export var AfriexTransactionType;
(function (AfriexTransactionType) {
    AfriexTransactionType["ACH"] = "ACH";
    AfriexTransactionType["DEPOSIT"] = "DEPOSIT";
    AfriexTransactionType["WITHDRAW"] = "WITHDRAW";
    AfriexTransactionType["TRANSFER"] = "TRANSFER";
    AfriexTransactionType["SWAP"] = "SWAP";
    AfriexTransactionType["REVERSAL"] = "REVERSAL";
    AfriexTransactionType["REFERRAL"] = "REFERRAL";
    AfriexTransactionType["BONUS"] = "WELCOME_BONUS";
    AfriexTransactionType["CASH_BACK_BONUS"] = "CASH_BACK_BONUS";
    AfriexTransactionType["E2E"] = "E2E";
    AfriexTransactionType["SCHEDULED"] = "SCHEDULED";
    AfriexTransactionType["REWARD"] = "REWARD";
    AfriexTransactionType["SEND"] = "SEND";
    AfriexTransactionType["SUBSCRIPTION"] = "SUBSCRIPTION";
    AfriexTransactionType["VIRTUAL_CARD_LOAD"] = "VIRTUAL_CARD_LOAD";
    AfriexTransactionType["VIRTUAL_CARD_UNLOAD"] = "VIRTUAL_CARD_UNLOAD";
    AfriexTransactionType["VIRTUAL_CARD_SPEND"] = "VIRTUAL_CARD_SPEND";
    AfriexTransactionType["VIRTUAL_CARD_REFUND"] = "VIRTUAL_CARD_REFUND";
    AfriexTransactionType["VIRTUAL_CARD_REVERSAL"] = "VIRTUAL_CARD_REVERSAL";
    AfriexTransactionType["VIRTUAL_CARD_BLOCK"] = "VIRTUAL_CARD_BLOCK";
    AfriexTransactionType["VIRTUAL_CARD_DELETED"] = "VIRTUAL_CARD_DELETED";
    AfriexTransactionType["VIRTUAL_CARD_FX_FEE"] = "VIRTUAL_CARD_FX_FEE";
    AfriexTransactionType["VIRTUAL_CARD_AUTH"] = "VIRTUAL_CARD_AUTH";
})(AfriexTransactionType || (AfriexTransactionType = {}));
//# sourceMappingURL=AfriexTransactionType.js.map